import { Money } from "models/money";

export function getExcelData(data) {
  let rows = [];
  let count = 1;
  data.forEach((elem) => {
    rows.push({
      Numero: count,
      Empresa: elem.company,
      Ventas: Money(elem.total),
      PrimerTrimestre: Money(elem.quarterSales1),
      SegundoTrimestre: Money(elem.quarterSales2),
      TercerTrimestre: Money(elem.quarterSales3),
      CuartoTrimestre: Money(elem.quarterSales4),
    });
    count++;
  });
  return rows;
}
